<template>
  <Row>
    <Col cols="12">
      <DomainHeading :title="lc.title" />
    </Col>
    <Col cols="12">
      <FaviconCard />
    </Col>
  </Row>
</template>

<script>
import { Row, Col, useLocale } from '@locaweb/design-system-vue'
import DomainHeading from '@/components/DomainHeading.vue'
import FaviconCard from './ManageFavicon/FaviconCard.vue'

export default {
  name: 'ManageFaviconView',
  components: {
    DomainHeading,
    FaviconCard,
    Row,
    Col
  },
  setup () {
    const lc = useLocale('site.favicon')

    return { lc }
  }
}
</script>
